import { _defineProperty } from "./index13.js";
var NmcsRules = class {
	constructor(initialState) {
		_defineProperty(this, "initialState", void 0);
		this.initialState = initialState;
	}
	getActionCost(_action) {
		return 0;
	}
	pickActionWithPolicy(validActions, rng) {
		return validActions[Math.floor(rng() * validActions.length)];
	}
};
export { NmcsRules };

//# sourceMappingURL=index151.js.map